/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InitiativeImageReference } from '../../models/initiative-image-reference';

export interface CreateInitiativeImageReference$Params {
  initiativeId: string;
      body?: InitiativeImageReference
}

export function createInitiativeImageReference(http: HttpClient, rootUrl: string, params: CreateInitiativeImageReference$Params, context?: HttpContext): Observable<StrictHttpResponse<InitiativeImageReference>> {
  const rb = new RequestBuilder(rootUrl, createInitiativeImageReference.PATH, 'post');
  if (params) {
    rb.path('initiativeId', params.initiativeId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InitiativeImageReference>;
    })
  );
}

createInitiativeImageReference.PATH = '/initiative/{initiativeId}/images';
